import React, { useEffect, useState } from 'react'
import Footer from '../component/Footer/Footer'
import Header from '../component/Header/Header'
import HomeHero from '../component/HomeHero/HomeHero'
import { InlineWidget,useCalendlyEventListener } from "react-calendly";
import { useNavigate, useParams } from 'react-router-dom';
import { Spinner } from 'react-bootstrap';

function BookConsultationForm() {
  
    const { id } = useParams();
    const [iframeSrc, setIframeSrc] = useState("");
    const navigate = useNavigate()

     useCalendlyEventListener({
    onEventScheduled: (event) => {
      console.log("Event booked:", event.data.payload);
      navigate("/thank-you");
    },
  });

   useEffect(() => {
      switch (id) {
        case "":
          window.location.href = "tel:+416-849-5555";
          break;
        case 'membership':
          setIframeSrc(
            "https://calendly.com/ttc55avenue/membership-appointment"
          );
          break;
        case 'women':
          setIframeSrc(
            "https://calendly.com/ttc55avenue/women-pelvic-floor-appointment"
          );
          break;
        case "iv-therapy":
          setIframeSrc(
            "https://calendly.com/ttc55avenue/iv-therapy-appointment"
          );
          break;
        case 'ed':
          setIframeSrc(
            "https://calendly.com/ttc55avenue/ed-treatment-appointment"
          );
          break;
           case 'men':
        setIframeSrc(
        "https://calendly.com/ttc55avenue/men-pelvic-floor-appointment"
        );
        break;
      case 'sports-medicine':
        setIframeSrc(
          "https://calendly.com/ttc55avenue/sports-medicine-appointment"
        );
        break;
      case 'audiology':
        setIframeSrc(
          "https://calendly.com/ttc55avenue/audiology"
        );
        break;
      case 'dna-clinic':
        setIframeSrc(
          "https://calendly.com/ttc55avenue/dna-clinic-appointment"
        );
        break;
      case 'global-medical':
        setIframeSrc(
          "https://calendly.com/ttc55avenue/global-medical-consulting-appointment"
        );
        break;
      case 'medical-aesthetics':
        setIframeSrc(
          "https://calendly.com/ttc55avenue/medical-aesthetics"
        );
        break;
      case 'aging-wellness':
        setIframeSrc(
          "https://calendly.com/ttc55avenue/aging-wellness-appointment"
        );
        break;
      case 'naturopathic':
        setIframeSrc(
          "https://calendly.com/ttc55avenue/naturopathic-medicine-appointment"
        );
        break;
      case 'orthopaedic':
        setIframeSrc(
          "https://calendly.com/ttc55avenue/orthopaedic-appointment"
        );
        break;
        default:
          window.location.href = "tel:+416-849-5555";
      }
    }, [id]);

  return (
    <div className='Book-form'>
         <Header/>
         <HomeHero
            heading='Book a Consultation'
            content=''
            textCtaBlack={true}
            headingBlack={true}
            showLogo={false}
            plainCta={false}
            textCenter={true}
            fullWidth={true}
            btn={false}
            bgImage={"/images/creatives/gradient-bg-3.png"}
        />

        <div className='container-fluid'>
          {
            iframeSrc?
            <div className='py-4'>
              <InlineWidget 
              url={iframeSrc}
             
              />
            </div>
            :
            <div className='d-flex align-items-center justify-content-center py-5'>
              <Spinner/>
            </div>
          }

        </div>

         <Footer
          newsletterSection={false}
        />
    </div>
  )
}

export default BookConsultationForm